import React from "react";
import { Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom";

import { selectSetting } from "../../../../../features/global/globalSlice";
import { selectSelectedLeague } from "../../../../../features/leaguemgmt/leagueManagementSlice";
import { useAppSelector } from "../../../../../hooks/reduxHooks";
import { ISiteSetting, ITeam } from "../../../../../types/api";

const CreateGameButton = ({
    currentTeam,
}: {
    currentTeam: ITeam | undefined;
}): React.JSX.Element => {
    const currentLeague = useAppSelector(selectSelectedLeague);
    const { setting: youthCreateLink } = useAppSelector(state =>
        selectSetting(state, "majorybl_display_create_game_link_for_coaches"),
    ) as ISiteSetting;
    const { setting: hsCreateLink } = useAppSelector(state =>
        selectSetting(
            state,
            "majorybl_hs_display_create_game_link_for_coaches",
        ),
    ) as ISiteSetting;

    const createLink =
        currentLeague?.season === "Youth" ? youthCreateLink : hsCreateLink;

    const user = useAppSelector(state => state.auth.user);

    return createLink === "true" || user!.userLevel <= 2 ? (
        <Row>
            <Col>
                <Link
                    to={`/coachs-clubhouse/team/${currentTeam?.id}/schedule/create-game`}
                    className="btn btn-primary"
                >
                    Create Game
                </Link>
            </Col>
        </Row>
    ) : (
        <></>
    );
};

export default CreateGameButton;
